import { endOfDay, startOfDay, subDays } from "date-fns";

export type PeriodValue =
  | "today"
  | "yesterday"
  | "24h"
  | "7d"
  | "14d"
  | "30d"
  | "custom";

export interface DateRange {
  startDate: Date;
  endDate: Date;
}

export interface ComparisonPeriod {
  type: "none" | "previous" | "previousMonth" | "previousYear";
  label: string;
}

export interface FilterState {
  period: PeriodValue;
  comparison: ComparisonPeriod | null;
  dateRange: DateRange;
  customDateRange?: DateRange;
}

export interface FilterQueryParams {
  start_date: string;
  end_date: string;
  period: PeriodValue;
  comparison_type?: ComparisonPeriod["type"] | null;
  comparison_label?: string | null;
  custom_start_date?: string;
  custom_end_date?: string;
}

export const createDefaultComparison = (): ComparisonPeriod => ({
  type: "none",
  label: "Sem comparação",
});

export const createDefaultFilterState = (): FilterState => {
  const now = new Date();

  return {
    period: "7d",
    comparison: createDefaultComparison(),
    dateRange: {
      // "Últimos 7 dias" sem contar o dia atual: D-7 até D-1
      startDate: startOfDay(subDays(now, 7)),
      endDate: endOfDay(subDays(now, 1)),
    },
  };
};

export const cloneFilterState = (state: FilterState): FilterState => ({
  period: state.period,
  comparison: state.comparison ? { ...state.comparison } : null,
  dateRange: {
    startDate: new Date(state.dateRange.startDate),
    endDate: new Date(state.dateRange.endDate),
  },
  ...(state.customDateRange && {
    customDateRange: {
      startDate: new Date(state.customDateRange.startDate),
      endDate: new Date(state.customDateRange.endDate),
    },
  }),
});

const getEffectiveDateRange = (state: FilterState): DateRange => {
  if (state.period === "custom" && state.customDateRange) {
    return state.customDateRange;
  }

  return state.dateRange;
};

/**
 * Formata a data como YYYY-MM-DD no fuso horário local.
 * (Evita o bug comum de "pular" o dia ao usar toISOString() em fusos negativos.)
 */
export const formatDateToISO = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};
